export const getProviderApiPrefix = (sourceType?: string | null): string => {
    if (sourceType === "vehicle_logistics") {
        return "/suppliers/vehicle/logistics";
    }

    return "/suppliers/alp";
};

